import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from '../scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from '../scripts/apperyio/apperyio_mapping_helper';
import {
    ModalController
} from '@ionic/angular';
import {
    ExportedClass as UserService
} from '../scripts/custom/UserService';
import {
    User
} from '../scripts/interfaces';
import {
    ViewChild
} from '@angular/core';
@Component({
    templateUrl: 'Settings.html',
    selector: 'page-settings',
    styleUrls: ['Settings.css', 'Settings.scss']
})
export class Settings {
    public viewMode: boolean;
    public savedPhoto: string;
    public user_info: User;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    @ViewChild('_aio_content') _aio_content;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    @ViewChild('j_154', {
        static: false
    }) public j_154;
    @ViewChild('form', {
        static: true
    }) public form;
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public modalController: ModalController, public userService: UserService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this.viewMode = true;
        this.aioChangeDetector = this.$aio_changeDetector;
    }
    ngOnInit() {
        this.Apperyio.setThinScrollIfNeeded();
        this.pageNgOnInit__j_148();
    }
    ionViewWillEnter() {
        window.parentCurrentScreen = window.currentScreen;
        window.currentScreen = this;
    }
    ionViewDidEnter() {
        this.pageIonViewDidEnter__j_148();
    }
    ionViewDidLeave() {
        window.currentScreen = window.parentCurrentScreen;
        delete window.parentCurrentScreen;
    }
    async pageIonViewDidEnter__j_148(event?, currentItem?) {
        let mappingData: any = {};
        let __aio_tmp_val__: any;
        /* Mapping */
        mappingData.j_150__visible = () => ((value) => {
            return value;
        })(this.$aio_mappingHelper.getSubdata(this.viewMode, []));
        mappingData.j_153__imageSrc = () => this.$aio_mappingHelper.getSubdata(this.user_info, ["personal", "Photo"]);
        this.mappingData = { ...this.mappingData,
            ...mappingData
        };
    }
    async pageNgOnInit__j_148(event?, currentItem?) {
        let __aio_tmp_val__: any;
        /* Run TypeScript */
        this.user_info = this.userService.user_info;
        console.log("user name " + this.user_info.username);
    }
    async filepickerIonChange__j_154(event?, currentItem?) {
        let __aio_tmp_val__: any;
        /* Invoke data service */
        this.invokeService_PhotoFileReadService();
    }
    async closebuttonClick__j_189(event?, currentItem?) {
        let __aio_tmp_val__: any;
        /* Run TypeScript */
        this.userService.user_info = this.user_info;
        this.modalController.dismiss();
    }
    private $aio_dataServices = {
        "PhotoFileReadService": "invokeService_PhotoFileReadService"
    };
    invokeService_PhotoFileReadService(cb?: Function) {
        this.Apperyio.getService("FileReadService_Profile").then(
            async (service) => {
                if (!service) {
                    console.log("Error. Service was not found.");
                    return;
                }
                let data = {};
                let __aio_tmp_val__: any;
                this.$aio_changeDetector.detectChanges();
                data = this.$aio_mappingHelper.updateData(data, ["resultFormat"], 'DATA_URL');
                /* Mapping */
                data = this.$aio_mappingHelper.updateData(data, ["fileInput"], this.$aio_mappingHelper.getComponentPropValue.call(this, 'j_154', 'ionic5filepicker', 'value'));
                service.execute({
                    data: data
                }).subscribe(
                    /* onsuccess */
                    async (res: any) => {
                        let mappingData: any = {};
                        /* Mapping */
                        this.user_info = this.$aio_mappingHelper.updateData(this.user_info, ["personal", "Photo"], this.$aio_mappingHelper.getSubdata(res, ["data"]));
                        this.mappingData = { ...this.mappingData,
                            ...mappingData
                        };
                        if (cb && typeof cb === "function") cb(res);
                    },
                    (err: any) => {
                        console.log(err);
                    }
                )
            }
        );
    }
}